<h2 mat-dialog-title> Alterar status - {{ data.param.id }}</h2>
<mat-dialog-content class="mat-typography">
    <div *ngIf="schedule">
        <b> {{ schedule.type }}:</b> {{ schedule.procedure ? schedule.procedure.name : '' }} 
        <span *ngIf="schedule.organization">{{ schedule.organization }}</span> <br>
        <b> Data e Hora:</b> {{ layout.dateTimeFormat(schedule.dateStart) }} 
     
        </div>
        <mat-form-field class="example-full-width" appearance="outline">
            <mat-label>Status</mat-label>
            <mat-select [(value)]="status">
                <mat-option *ngFor="let item of scheduleStatus" [value]="item.id">
                    {{item.text}}
                </mat-option>
            </mat-select>
        </mat-form-field>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button  color="warn" [mat-dialog-close]="false">Cancelar</button>
  <button mat-flat-button  color="primary" (click)="saveStatus()" cdkFocusInitial>Salvar</button>  
</mat-dialog-actions>



